import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './tabs-standalone.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
import * as $ from 'jquery';
var TabsStandalone = /** @class */ (function (_super) {
    tslib_1.__extends(TabsStandalone, _super);
    function TabsStandalone(element) {
        return _super.call(this, element) || this;
    }
    TabsStandalone.prototype.init = function () {
        var _this = this;
        if (this.element.getAttribute('data-autoheight')) {
            this.autoHeight = this.element.getAttribute('data-autoheight').toString();
        }
        else {
            this.autoHeight = 'true';
        }
        this.tabComponent = $(this.element);
        this.tabsContent = Array.from(this.tabComponent.find('.tabs-standalone__item-content'));
        setTimeout(function () {
            _this.equalHeights();
        }, 100);
        this.initTabs();
        this.tabTriggers = Array.from(this.tabComponent.find('.js-tab-trigger'));
        this.accordionTriggers = Array.from(this.tabComponent.find('.js-accordion-trigger'));
        this.activeTabTrigger = this.tabComponent.find('.tabs-standalone__item--active');
        this.activeTab = this.tabComponent.find('.tabs-standalone__item-content--active');
    };
    TabsStandalone.prototype.bindEvents = function () {
        var _this = this;
        this.tabTriggers.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleTabs(event);
        }); });
        this.accordionTriggers.map(function (item) { return item.addEventListener('click', function (event) {
            _this.stopVideos();
        }); });
        window.addEventListener('resize', this.onResize.bind(this));
    };
    TabsStandalone.prototype.onResize = function () {
        var _this = this;
        setTimeout(function () {
            _this.equalHeights();
        }, 100);
    };
    TabsStandalone.prototype.initTabs = function () {
        var tabs = this.tabComponent.find('.tabs-standalone__item');
        var tabsContent = this.tabsContent;
        for (var i = 0; i < tabs.length; i++) {
            var tabGuid = this.generateGuid();
            $(tabs[i]).attr('data-target', "tabs-standalone__item-" + tabGuid);
            $(tabsContent[i]).attr('id', "tabs-standalone__item-" + tabGuid);
        }
    };
    TabsStandalone.prototype.equalHeights = function () {
        if (this.autoHeight == 'true') {
            var elements = this.tabsContent;
            for (var i = 0; i < elements.length; i++) {
                elements[i].style.height = 'auto';
            }
            if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {
                var tallestElement = 0;
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    var elHeight = el.offsetHeight;
                    if (elHeight > tallestElement) {
                        tallestElement = elHeight;
                    }
                }
                for (var i = 0; i < elements.length; i++) {
                    elements[i].style.height = tallestElement + "px";
                    if (!elements[i].classList.contains('tabs-standalone__item-content--active')) {
                        elements[i].style.height = '0';
                    }
                }
            }
        }
    };
    TabsStandalone.prototype.toggleTabs = function (event) {
        this.stopVideos();
        if (!$(event.currentTarget).hasClass('tabs-standalone__item--active')) {
            this.closeTab();
            this.activeTabTrigger = $(event.currentTarget);
            this.activeTab = this.tabComponent.find("#" + this.activeTabTrigger.attr('data-target'));
            this.openTab();
        }
        this.equalHeights();
    };
    TabsStandalone.prototype.generateGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    TabsStandalone.prototype.closeTab = function () {
        this.activeTabTrigger.removeClass('tabs-standalone__item--active');
        this.activeTab.removeClass('tabs-standalone__item-content--active');
    };
    TabsStandalone.prototype.openTab = function () {
        this.activeTabTrigger.addClass('tabs-standalone__item--active');
        this.activeTab.addClass('tabs-standalone__item-content--active');
    };
    TabsStandalone.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    TabsStandalone.prototype.stopVideos = function () {
        var videosVidavee = Array.from(this.element.querySelectorAll('video'));
        var videosYoutube = Array.from(this.element.querySelectorAll('#video__external'));
        videosVidavee.map(function (video) {
            if (video.player) {
                video.player.pause();
            }
        });
        videosYoutube.map(function (video) {
            //this.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            console.log(video);
        });
    };
    return TabsStandalone;
}(Base));
export { TabsStandalone };



//////////////////
// WEBPACK FOOTER
// ./components/tabs-standalone/tabs-standalone.component.ts
// module id = 538
// module chunks = 0